import { cartTotal } from 'data/mock-data';

const mock = () => ({
  data: { cartTotals: cartTotal },
});

export default mock;
